import { Controller } from "@hotwired/stimulus"

// Scroll effects for the Cosy Fantasy landing, ported from the mockup's page script:
// - [data-reveal] / children of [data-reveal-children] fade+rise in on viewport entry,
//   with a 110ms cascade between siblings of a group (CSS holds the hidden state).
// - [data-parallax="N"] drifts by N px against the scroll.
// Classic JS only (old Babel — no ?./??).
export default class extends Controller {
  connect() {
    this.setupReveal()
    this.setupParallax()
  }

  disconnect() {
    if (this.io) this.io.disconnect()
    if (this.onScroll) window.removeEventListener("scroll", this.onScroll)
  }

  setupReveal() {
    const targets = []
    this.element.querySelectorAll("[data-reveal]").forEach((el) => targets.push(el))
    this.element.querySelectorAll("[data-reveal-children]").forEach((group) => {
      Array.prototype.forEach.call(group.children, (child) => {
        child.setAttribute("data-reveal-child", "")
        targets.push(child)
      })
    })

    const show = (el) => {
      const parent = el.parentNode
      const siblings = parent
        ? Array.prototype.filter.call(parent.children, (c) => c.hasAttribute("data-reveal-child"))
        : []
      const i = siblings.indexOf(el)
      if (i > 0) el.style.transitionDelay = (i * 110) + "ms"
      el.style.opacity = "1"
      el.style.transform = "none"
    }

    if (!("IntersectionObserver" in window)) {
      targets.forEach(show)
      return
    }
    this.io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          show(entry.target)
          this.io.unobserve(entry.target)
        }
      })
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" })
    targets.forEach((el) => this.io.observe(el))
  }

  setupParallax() {
    const elements = []
    this.element.querySelectorAll("[data-parallax]").forEach((el) => elements.push(el))
    if (!elements.length) return
    if (window.matchMedia("(prefers-reduced-motion:reduce)").matches) return

    const apply = () => {
      const vh = window.innerHeight || 800
      elements.forEach((el) => {
        const rect = el.getBoundingClientRect()
        const progress = (rect.top + rect.height / 2 - vh / 2) / vh
        const amount = parseFloat(el.getAttribute("data-parallax")) || 20
        el.style.transform = "translateY(" + (-progress * amount).toFixed(1) + "px)"
      })
    }

    let ticking = false
    this.onScroll = () => {
      if (ticking) return
      ticking = true
      requestAnimationFrame(() => {
        apply()
        ticking = false
      })
    }
    window.addEventListener("scroll", this.onScroll, { passive: true })
    apply()
  }
}
